import React,{useEffect} from 'react';
import Header from '../../components/Header';
import ContactMain from './ContactMain';
import Footer from '../../components/Footer';


const Contact = () => {
      useEffect (() => {
      document.title = "Contact Us | Society of Aquaculture Professionals";
    }, []);
  return (
    <>
      <Header/>

      <ContactMain />

      <Footer/>
    </>
  );
};

export default Contact;
